import React, { useEffect, useRef, memo } from "react";
import L from "leaflet";
import pointInPolygon from "point-in-polygon"
import "leaflet.markercluster";
import "styles/main/Map.sass"
import Units from 'resources/units'
import Results from 'resources/resultsPro'
import ResultsNew from 'resources/resultsNew'

import ZonesLQ from 'resources/zonesLQ'
import { useSelector, useDispatch } from 'react-redux';

const useOnUpdate = (callback, deps) => {
  const isFirst = useRef(true);
  useEffect(() => {
    if (!isFirst.current) {
      callback();
    }
  }, deps);

  useEffect(() => {
    isFirst.current = false;
  }, []);
};

//export default useOnUpdate;


export default function Map(props) {
  const dispatch = useDispatch();
  const zone = useSelector((state) => state.zone);
  const universe = useSelector((state) => state.universe);
  const features = useSelector((state) => state.features);
  const product = useSelector((state) => state.product);
  const dataset = useSelector((state) => state.dataset);
  const geoArea = useSelector((state) => state.geoArea);
  const parameter = useSelector((state) => state.parameter);
  const depth = useSelector((state) => state.depth);
  const setActive = (props.setActive)
  var map = useRef();
  var subzoneCenters = useRef();
  var layersG = useRef();
  var legend = useRef()
  var forecasts = useRef()
  var currFcst = useRef()
  var numMarkers = useRef()
  var markersG = useRef()
  var hayCluster = useRef(true)
  const markers = require.context('resources/errors/CLASS2',true, /\.json$/, 'lazy')


  useEffect(() => { 
    map.current = L.map('map', {zoomControl: false, maxZoom: 15,zoomAnimationThreshold: 15}).setView([43,-3.5], 3);
    var tiles = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      noWrap: true,
      maxZoom: 18,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map.current);
    L.control.zoom({position: 'bottomright'}).addTo(map.current);
    L.Control.center =  L.Control.extend({
          onAdd: function() {
            var div = L.DomUtil.create('div');
            div.id = 'centerB';
            div.innerHTML = `<div id="centerImg" />`
            return div;
          }
        })
    new L.Control.center({position: 'bottomright'}).addTo(map.current);
    layersG.current = L.featureGroup().addTo(map.current);
    draw(getSubZone())
  }, []);

  useEffect(() => { 
    console.log('render Map')
  });

  var getSubZone = () => {
    return undefined
    return geoArea == 'full-domain' ? undefined : geoArea
  }

  useOnUpdate(() => {
    draw(geoArea == 'full-domain' ? undefined : geoArea)
  }, [product, dataset,geoArea,zone, depth])


  function getPolys(subZone){
    subzoneCenters.current = {}
    return L.geoJSON(features,{
      className: subZone? '':'poly',
      filter: function(feature) {
        if (!subZone)
          return true
        if (feature.properties.subZone == subZone)
          return true
        return false  
      },
      style: function (featureObject) {
        return {
          color: 'rgb(11,97,146)',
          stroke: subZone ? true: false,
          fillOpacity: subZone ? 0.2: 0.2,
        };
      },
      onEachFeature: function (feature, layer) {
        if (feature.properties.subZone.indexOf('pacific') !== -1) { //CUANDO SE ARREGLEN LAS LINEAS DE COSTA NO SERIA NECESARIO
          subzoneCenters.current[feature.properties.subZone] = []
          for (var i in layer.getLatLngs())
            subzoneCenters.current[feature.properties.subZone].push({center: L.polygon(layer.getLatLngs()[i]).getBounds().getCenter(), layer: layer})
        }
        else
          subzoneCenters.current[feature.properties.subZone] =  [{center: layer.getBounds().getCenter(), layer: layer}]
        
         /* if (!subZone){
            layer.on('click', function(ev){
              //draw(ev.target.feature.properties.NAME)
              setGeoArea(ev.target.feature.properties.subZone)
            })
            layer.on('mousemove', function(ev){
               L.DomEvent.stopPropagation(ev)
            })
            layer.on('mouseover', function(ev){
              overLayer(layer)
            })
          }*/
        }
    });
  }

  function draw(subZone){
    if (product) {
      console.log(numMarkers)
      if (legend.current) map.current.removeControl(legend.current)
      if (forecasts.current) map.current.removeControl(forecasts.current)
      if (numMarkers.current) map.current.removeControl(numMarkers.current)
      layersG.current.clearLayers();
      var polysG = getPolys(subZone)
      if (polysG.getLayers().length > 0){
        map.current.off('mousemove')
        map.current.setMaxBounds(polysG.getBounds())
        map.current.once('moveend', function(){
          if (!subZone) L.rectangle(polysG.getBounds(), {fillOpacity: 0, color: 'rgb(11,97,146)'} ).addTo(layersG.current)  
          polysG.addTo(layersG.current)
          getMarkers(subZone).addTo(layersG.current)
          getResultsNew(subZone).addTo(layersG.current)
          if (zone == "global" && subZone == undefined) map.current.setZoom(map.current.getZoom()+1)
        })
        map.current.options.minZoom = 0
        map.current.fitBounds(polysG.getBounds())
        document.getElementById('centerB').onclick = () => {draw(getSubZone())}
        //map.current.options.minZoom = map.current.getBoundsZoom(polysG.getBounds())
      }
    }
  }

  function getCluster(markersG){
    return L.markerClusterGroup({maxClusterRadius: 15, showCoverageOnHover: false, removeOutsideVisibleBounds: false,
      iconCreateFunction: function() {return L.divIcon({className:'cluster', iconSize: [14, 14], html: "<div class='clusterIcon markerAnim' />" })}
    })
    .on('clustermousemove', function(ev){
      L.DomEvent.stopPropagation(ev)
    })
    .on('clustermouseover', function(c){
      c.layer.bindTooltip(clusterPop(c), {offset: L.point(20, 0), permanent: true})
    })
    .on('clustermouseout', function(c){
      c.layer.unbindTooltip()
    }).addTo(markersG) 
  }

  function clusterPop(c){
    var popupText = "<div id='headerTt'><b>Marker Cluster</b></div>" +
    "<div id='contentTt' class='border"+"blue"+"O'>" 
    c.layer.getAllChildMarkers().forEach(function(m){
      popupText += "<p style =\"margin:0; color:"+rmsdColor(m.feature.properties.rmsd).color+"\"><b>Ref:</b> " + m.feature.properties.NAME + '</p>'
    })
    popupText += "<i>Click to expand cluster</i></div>"
    return popupText;
  }

  function resultPop(area,r){
    var popupText = "<div id='headerTt' class='"+"blue"+"OH'><b>"+area+" - RMSD ("+getUnit()+")</b>" +
    "</div><div id='contentTt' class='border"+"blue"+"O'>" 
    for (var v in r) {
      popupText += "<p style =\"margin:0; color:"+rmsdColor(r[v]).color+"\"><b>"+v+":</b> " + Math.sqrt(r[v]).toFixed(2) + '</p>'
    }
    popupText += "<i>Click to open area time series</i></div>"
    return popupText
  }

  function getUnit(){
    if (parameter in Units)
      return Units[parameter]
    return ""
  }

/*  function overLayer(layer){
    for (var s in subzoneCenters.current)
      if (subzoneCenters.current[s][0].layer != layer)
        subzoneCenters.current[s][0].layer._path.style.opacity = 0
    layer.bringToFront();
    setTimeout(function(){ //Moving a DOM element restarts transition, this fake timeout solves it.
      layer._path.style.opacity = 1
    }, 0)
    for (var result of document.getElementsByClassName('result')) 
      result.style.opacity = 0.1;
    for (var result of document.getElementsByClassName(layer.feature.properties.subZone))
      result.style.opacity = 0.8;
    map.current.once('mousemove', function(ev){
      for (var s in subzoneCenters.current)
        subzoneCenters.current[s][0].layer._path.style.opacity = 0
      for (var result of document.getElementsByClassName('result'))
        result.style.opacity = 0.8;
    })
  }*/

  function cleanHgl(){
    for (var s in subzoneCenters.current)
      subzoneCenters.current[s][0].layer._path.style.opacity = 0
    for (var result of document.getElementsByClassName('result')) 
      result.style.opacity = 1;
  }

  function areaHgl(subZone){
    subzoneCenters.current[subZone][0].layer._path.style.opacity = 1
    for (var result of document.getElementsByClassName('result')) 
      result.style.opacity = 0.1;
    for (var result of document.getElementsByClassName(subZone))
      result.style.opacity = 1;
  }

  function getMarkers(subZone){
    var nMarkers = 0;
    markersG.current = L.layerGroup();
    if (dataset != 'sst-insitu')
      return markersG.current
    var markersCont = hayCluster.current?getCluster(markersG.current):markersG.current;
    try{
      //var m = markers('./'+changeNameAreas(zone) + '/'+changeNameParameter(parameter)+'/' + changeNameProduct(product) + '_'+changeNameParameter(parameter)+'.json').then(function(features) {
      var m = markers('./'+zone + '/'+parameter+'/'+dataset+'.json').then(function(features) {
        L.geoJSON(features,{
          filter: function(feature, layer) {
            if (!subZone){
              nMarkers++
              return true
            }
            for (var i in ZonesLQ[subZone]){
              //var p = L.polygon(ZonesLQ[subZone][i]);
              //if (p.contains(L.latLng([feature.geometry.coordinates[1], feature.geometry.coordinates[0]]))){
              if (pointInPolygon(feature.geometry.coordinates, ZonesLQ[subZone][i])) {
                nMarkers++
                return true
              }
            }
            return false  
          },
          pointToLayer: function(feature, latlng) {
            var c = rmsdColor(feature.properties.rmsd);
            return L.circleMarker(latlng, {className: 'markerAnim', radius:5, fillColor:c.fColor, color:c.color, fillOpacity:1, weight:2})
          },
          onEachFeature: function (feature, layer) {
            layer.on('click', function(e){
              var url = "https://pqd.mercator-ocean.fr/charts/class2NEW.html?region="+zone+"&universe="+universe.toLowerCase()+"&station="+layer.feature.properties.NAME+"&dataset="+"sst-insitu"+"&product="+product
              dispatch({ type: 'SET_POPUP', payload: {
                title: "Time Series",
                content: "<div id='htmlCont' style='min-height: 380px; min-width:500px'><iframe style='border:none; width:100%; height:100%;' src='"+url+"'></iframe></div>"
              }})
            });
            layer.on('mousemove', function(ev){
              L.DomEvent.stopPropagation(ev)
            })
            layer.on('mouseover', function(e){
              layer.setStyle({radius: 7})
            });
            layer.on('mouseout', function(e){
              layer.setStyle({radius: 5})
            });
            if(layer.feature.properties.rmsd != "" && !isNaN(layer.feature.properties.rmsd)){
              let popupText = "<div id='headerTt'><b>Ref:</b> " + layer.feature.properties.NAME.bold() +
                "</div><div id='contentTt' style='color:"+getColor(layer.feature.properties.rmsd)+"'>"+
                "<ul><li><b>Mean:</b>" +
                "<ul><li><b>Reference:</b> " + layer.feature.properties.meanRef + ' ' + getUnit() + '</li>' +
                "<li><b>Model: </b>" + layer.feature.properties.meanMod + ' ' + getUnit() + '</li></ul>' +
                "<li><b>Rmsd: </b>" + layer.feature.properties.rmsd + ' ' + getUnit() + '</li>' +
                "<li><b>Bias: </b>" + layer.feature.properties.bias + ' ' + getUnit() + '</li>' + 
                "<li><b>Correlation: </b>" + layer.feature.properties.corr + '</li>' +
                "<li><b>Variance:</b>" +
                "<ul><li><b>Reference: </b>" + layer.feature.properties.varRef + ' ' + getUnit() + '</li>' +
                "<li><b>Model: </b>" + layer.feature.properties.varMod + ' ' + getUnit() + '</li></ul>' +
                "<li><b>Scatter index: </b>" + layer.feature.properties.si + '</li></ul>' +
                "</br><i>Click to open time series</i></div>"
              layer.bindTooltip(popupText, {offset: L.point(20, 0)})
            }
            //layer.on('tooltipopen', function(){changeTri()})
          }    
        }).addTo(markersCont)

        L.Control.legend =  L.Control.extend({
          onAdd: function() {
            var div = L.DomUtil.create('div');
            div.id = 'legend';
            div.innerHTML = 
              `<img />`
            return div;
          }
        })
        legend.current = new L.Control.legend({position: 'topright'}).addTo(map.current);

        L.Control.numMarkers = L.Control.extend({
          onAdd: function() {
            var div = L.DomUtil.create('div');
            div.id = 'numMarkers';
            div.addEventListener('click', toggleCluster)
            div.innerHTML = '<div id="num" class="'+(hayCluster.current ? '':'dis')+'">'+nMarkers+'</div>'
            return div;
          }
        })
        numMarkers.current = new L.Control.numMarkers({position: 'topright'}).addTo(map.current);
      })
    } catch (e) {
      console.log("no hay markers para este producto")
    }
    return markersG.current
  }

  function toggleCluster(){
    layersG.current.removeLayer(markersG.current)
    hayCluster.current = !hayCluster.current
    if (legend.current) map.current.removeControl(legend.current)
    if (numMarkers.current) map.current.removeControl(numMarkers.current)
    getMarkers(geoArea == 'full-domain' ? undefined : geoArea).addTo(layersG.current)
  }

  function getColor(rmsd){
    if (rmsd <= 0.3) return "#28B800"
    if (rmsd > 0.3 && rmsd <= 0.5)  return "#B8AE00"
    if (rmsd > 0.5 && rmsd <= 1) return "#F58B00"
    if (rmsd > 1)return "#FF5C5C"
  }

  function changeTri(){
    var bRight = document.getElementsByClassName('leaflet-tooltip-right')
    for (let i in bRight)
      bRight[i].className = 'leaflet-tooltip leaflet-zoom-animated leaflet-tooltip-right blueBR' 
    var bLeft = document.getElementsByClassName('leaflet-tooltip-left')
    for (let i in bLeft)
      bLeft[i].className = 'leaflet-tooltip leaflet-zoom-animated leaflet-tooltip-left blueBL' 
  }

  function getResults(subZone){
    var resultsG = L.layerGroup();
    for (var s in subzoneCenters.current)
      for (var c in subzoneCenters.current[s]){
        try {
          var r = {}
            r = Results[zone][product][dataset][s]["values"]
          if (r != "" && ("analysis" in r || "12 hours" in r)){
            var title = ("12 hours" in r) ? r["12 hours"] : r["analysis"]
            var result = L.marker(subzoneCenters.current[s][c]["center"], 
              {r:r, layer:subzoneCenters.current[s][c]["layer"], icon: L.divIcon({className: s+' result', html:'<div>'+title.toFixed(2)+'</div>', iconSize: [0,0]})}).addTo(resultsG)
            if (!subZone)
              result.on('mouseover', function(ev){
                areaHgl(ev.target.options.layer.feature.properties.subZone)
                //setAppState({hglArea: ev.target.options.layer.feature.properties.subZone})
                ev.target.bindTooltip(resultPop(ev.target.options.layer.feature.properties.subZone, this.options.r), {offset: L.point(20, 0), permanent: true})
              })
              .on('mouseout', function(ev){
                  cleanHgl()
                //setAppState({hglArea:undefined})
                ev.target.unbindTooltip()
              })
              .on('click', function(ev){
                 dispatch({ type: 'SET_GEO_AREA', payload: ev.target.options.layer.feature.properties.subZone });
              });
            //L.circleMarker(subzoneCenters.current[s][c]["center"], {radius: 2}).addTo(resultsG)
          }
      } catch (e) {
        console.log("no hay results")
      }
      }
      return resultsG;
  }

  function clickForecasts(f){
    currFcst.current = f
  }

  function enterInfoFcst(ev) {
    dispatch({ type: 'SET_TOOLTIP', payload: {"title": "Which temporal horizon are you interested in?", "body": "Spatially averaged EANs are computed for different product horizon (including analysis and forecasted ones). Values on the bar refer to entire (Full Domain) region . By selecting specific horizon, the EANs on the Map are refreshed accordingly.", "x": ev.pageX + 10, "y": ev.pageY -30}})
  }

  function leaveInfoFcst(ev) {
    dispatch({ type: 'SET_TOOLTIP', payload: undefined})
  }

  function getResultsNew(subZone){
    var resultsG = L.layerGroup();
    var allFcst = [];
    try {
      var r = ResultsNew[zone+'-full-domain'][product][dataset][depth]
      for (var h in r)
        if (allFcst.indexOf(h) == -1)
          allFcst.push(h)
    } catch (e) {}
    for (var s in subzoneCenters.current)
      try {
        var r = ResultsNew[s][product][dataset][depth]
        for (var h in r)
          if (allFcst.indexOf(h) == -1)
            allFcst.push(h)
      } catch (e) {}
    if (!currFcst.current || allFcst.indexOf(currFcst.current) < 0 ) {
      if (allFcst.length > 0) {
        currFcst.current = allFcst[0]
      }
    }
    if (dataset != 'sst-insitu'){
      L.Control.forecasts =  L.Control.extend({
        onAdd: function() {
          var div = L.DomUtil.create('div');
          div.className = 'forecasts';
          div.innerHTML = "<div id='infoFcst'></div><div class='forecastTitle'><div>HORIZONS</div><div>FULL DOMAIN</div></div>"
          for (var f in allFcst) {
            var val = null
            try {
              val = Math.sqrt(ResultsNew[zone+'-full-domain'][product][dataset][depth][allFcst[f]]).toFixed(2)
            } catch (e) {}
            if (allFcst[f] == currFcst.current)
              div.innerHTML += "<div fcst='"+allFcst[f]+"' class='forecast active "+allFcst[f]+"'><div>"+allFcst[f].replace('ana','analysys').replace('fc', 'fcst')+"</div><div>"+val+"</div></div>"
            else
              div.innerHTML += "<div fcst='"+allFcst[f]+"' class='forecast "+allFcst[f]+"'><div>"+allFcst[f].replace('ana','analysys').replace('fc', 'fcst')+"</div><div>"+val+"</div></div>"
          }
          return div;
        }
      })
      forecasts.current = new L.Control.forecasts({position: 'bottomleft'}).addTo(map.current);
    }
    if (document.querySelector('#infoFcst')){
      document.querySelector('#infoFcst').onmouseenter = (ev) => {enterInfoFcst(ev)}
      document.querySelector('#infoFcst').onmouseleave = (ev) => {leaveInfoFcst(ev)}
    }
    for (var f in allFcst)
     document.querySelector('.forecast.'+allFcst[f]).onclick = (ev) => {clickForecasts(ev.currentTarget.getAttribute('fcst')); draw(subZone)}
    for (var s in subzoneCenters.current)
      for (var c in subzoneCenters.current[s]){
        try {
          var r = ResultsNew[s][product][dataset][depth]
          var title = Math.sqrt(r[currFcst.current])
          var result = L.marker(subzoneCenters.current[s][c]["center"], 
              {r:r, layer:subzoneCenters.current[s][c]["layer"], icon: L.divIcon({className: s+' result', html:(isNaN(title) ? '<div style="background-color:indianred">' : '<div>')+title.toFixed(2)+'</div>', iconSize: [0,0]})}).addTo(resultsG)
           
            if (!subZone)
              result.on('mouseover', function(ev){
                areaHgl(ev.target.options.layer.feature.properties.subZone)
                ev.target.bindTooltip(resultPop(ev.target.options.layer.feature.properties.subZone, this.options.r), {offset: L.point(20, 0), permanent: true})
              })
              .on('mouseout', function(ev){
                cleanHgl()
                ev.target.unbindTooltip()
              })
              .on('click', function(ev){
                 dispatch({ type: 'SET_GEO_AREA', payload: ev.target.options.layer.feature.properties.subZone });
                 setActive("charts")
              });

        } catch (e) {
          console.log("no hay results")
        }
      }
      return resultsG;
  }

  function rmsdColor(rmsd) {
    var color = ''
    var fColor = ''
    if (rmsd <= 0.3) {
      color = "#28B800"
      fColor = '#B4FF9F'
    }
    if (rmsd > 0.3 && rmsd <= 0.5) {
      color = "#B8AE00"
      fColor = '#F9FFA4'
    }
    if (rmsd > 0.5 && rmsd <= 1) {
      color = "#F58B00"
      fColor = '#FFD59E'
    }
    if (rmsd > 1) {
      color = "#FF5C5C"
      fColor = '#FFC2C2'
    }
    return {color:color, fColor:fColor}
  }

  function changeNameAreas(name) {
    switch (name) {
      case 'arctic':
        return 'ARC'
      case 'balticsea':
        return 'BAL'
      case 'global':
        return 'GLO'
      case 'ibi':
        return 'IBI'
      case 'medsea':
        return 'MEDSEA'
      case 'nws':
        return 'NWS'
      case 'blacksea':
        return 'BS'
      default:
        return null
    }
  }

  function changeNameParameter(name) {
    switch (name) {
      case 'Temperature':
        return 'SST'
      default:
        return null
    }
  }

  function changeNameProduct(product) {
    return product.replace('analysisforecast', 'analysis-forecast').toUpperCase().replace(/-/g, '_')
  }

  return <div id="map"/>
}